<template>
  <div>
    <router-view/>
    <!-- 子应用组件引入 -->
    <micro-apps></micro-apps>
  </div>
</template>

<script>
import microApps from "@/micro-app/component/microSub.vue";

export default {
  components: {
    microApps,
  },
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/micro-app/component/EmptyLayout.vue